import {registerEmailMakerSector} from '../../right-panel-registry';
import {deleteControl, duplicateControl, lockControl} from '../shared/common-action-controls';

/** Fallback sector — must be registered last so it only matches when no earlier entry did. */
registerEmailMakerSector(() => true, {
  title: (component) => {
    const type = component.get('type');
    return typeof type === 'string' ? type : window.i18next.t('pmwjs_element');
  },
  properties: [{control: duplicateControl}, {control: lockControl}, {control: deleteControl}],
});
